import $ from 'jquery';
import isViewport from '../../scripts/util/window/isViewport';
import {sm} from '../../scripts/util/window/isViewport';

export default class Tabs {
	constructor() {
		this.selectors = {
			el: '.js-tabs',
			control: '.js-tab-control',
			tab: '.js-tab',
			check: '.js-check-toggle',
			toggle: '.js-toggle',
			accord: '.js-accordeon',
			mainPage: {
				tabs: '.js-main-tabs'
			}
		};

		this.classes = {
			control: {
				active: 'tabs__control_state_active'
			},
			tab: {
				active: 'tabs__tab_state_active'
			},
			toggle: {
				active: 'toggle_state_active'
			}
		};

		this.$el = $(this.selectors.el);
		this.$window = $(window);
	}

	getNodes = () => {
		this.$control = $(this.selectors.control);
		this.$toggle = this.$el.find(this.selectors.toggle);
	}

	setTab = ($el, $control, $tab) => {
		const $controlActive = $el.find(`.${this.classes.control.active}`);
		const $tabActive = $el.find(`.${this.classes.tab.active}`);

		$controlActive.removeClass(this.classes.control.active);
		$tabActive.removeClass(this.classes.tab.active);
		$control.addClass(this.classes.control.active);
		$tab.addClass(this.classes.tab.active);
	}

	setToggle = $tab => {
		const $accord = $tab.closest(this.selectors.accord);
		const $toggles = $accord.find(this.selectors.toggle);
		const $curToggle = $tab.find(this.selectors.toggle);

		$toggles.removeClass(this.classes.toggle.active);
		$curToggle.addClass(this.classes.toggle.active);
	}

	tabOnClick = e => {
		const $target = $(e.target);
		const $el = $target.closest(this.selectors.el);
		const $tabs = $el.find(this.selectors.tab);
		const tabId = $target.data('tab');
		const $targetTab = $tabs.filter('[data-tab="' + tabId + '"]');
		const isToggleCheck = $target.closest(this.selectors.check).length;

		if (isToggleCheck) {
			this.setToggle($targetTab);
		}
		this.setTab($el, $target, $targetTab);
	}

	setHeight = () => {
		const $el = $(this.selectors.mainPage.tabs);
		if ($el.length && !isViewport(sm)) {
			setTimeout(() => $el.css('height', `${$el.outerHeight()}`), 201);
		} else {
			$el.removeAttr('style');
		}
	}

	toggleOnClick = e => {
		const $target = $(e.target);
		const $el = $target.closest(this.selectors.el);
		const $targetTab = $target.parent();
		const tabId = $targetTab.data('tab');
		const $targetControl = $el.find(this.selectors.control).filter('[data-tab="' + tabId + '"]');
		this.setTab($el, $targetControl, $targetTab);
	}

	render = () => {
		if (this.$el.length) {
			this.getNodes();
			this.$control.on('click', this.tabOnClick);
			this.$toggle.on('click', this.toggleOnClick);
			this.$window.on('load', this.setHeight);
			this.$window.on('resize', this.setHeight);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/tabs/tabs.js
 **/